export const buttonStyles = {
  base: "px-4 py-2 rounded-lg transition-all duration-200 font-medium focus:outline-none focus:ring-2 focus:ring-offset-2",
  primary: "bg-blue-500 hover:bg-blue-600 text-white focus:ring-blue-500",
  secondary: "bg-gray-200 hover:bg-gray-300 text-gray-800 focus:ring-gray-400",
  success: "bg-green-500 hover:bg-green-600 text-white focus:ring-green-500",
  danger: "bg-red-500 hover:bg-red-600 text-white focus:ring-red-500",
  disabled: "bg-gray-300 text-gray-500 cursor-not-allowed",
};

export const inputStyles = {
  base: "w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 transition-all duration-200",
  default: "border-gray-300 focus:border-blue-500 focus:ring-blue-200",
  error: "border-red-300 focus:border-red-500 focus:ring-red-200",
  disabled: "bg-gray-100 text-gray-500 cursor-not-allowed",
};

export const cardStyles = {
  base: "rounded-lg overflow-hidden transition-shadow duration-200",
  default: "bg-white border border-gray-200 hover:shadow-lg",
  inactive: "bg-red-50 border border-red-200",
};

export const tableStyles = {
  container: "overflow-x-auto shadow-md rounded-lg",
  table: "min-w-full divide-y divide-gray-200",
  header: "bg-gray-50",
  headerCell: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider",
  row: "bg-white hover:bg-gray-50",
  cell: "px-6 py-4 whitespace-nowrap text-sm text-gray-900",
};

export const gridStyles = {
  responsive: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6",
}; 